import React from 'react';
import { Sparkles } from 'lucide-react';

interface ChatSuggestionsProps {
  suggestions: string[];
  onSuggestionClick: (suggestion: string) => void;
}

export default function ChatSuggestions({ suggestions, onSuggestionClick }: ChatSuggestionsProps) {
  return (
    <div className="ml-11 flex flex-wrap gap-2">
      {suggestions.map((suggestion, index) => (
        <button
          key={index}
          onClick={() => onSuggestionClick(suggestion)}
          className="text-sm bg-white border border-blue-200 text-blue-600 px-3 py-1 rounded-full hover:bg-blue-50 transition-colors flex items-center space-x-1"
        >
          <Sparkles className="w-3 h-3" />
          <span>{suggestion}</span>
        </button>
      ))}
    </div>
  );
}